import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { LoginUrlService } from '../services/login-url.service';

@Injectable()
export class HttpStatus401Interceptor implements HttpInterceptor {
  constructor(private router: Router,
    private loginUrlService: LoginUrlService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        err => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              return;
            }

            if (err.error && err.error.loginUrl) {
              this.loginUrlService.loginUrl = err.error.loginUrl;
            }

            this.router.navigate(['httpstatus401']);
          }
        }));
  }
}
